import {
  CashIcon,
  EngineIcon,
  Food2Icon,
  GiveFiveIcon,
  PhoneIcon,
  TradeIcon,
  WarningIcon,
} from "@/shared/icons";
import { NotificationsAction } from "@/domains/notifications/constants/notificationsAction";
import { NotificationsActionColor } from "@/domains/notifications/constants/notificationsActionColor";
import { NotificationsActionType } from "@/domains/notifications/constants/notificationsActionType";

export const notificationsActionList: Record<NotificationsActionType, NotificationsAction> = {
  [NotificationsActionType.CarRefuel]: {
    icon: WarningIcon,
    color: NotificationsActionColor.Warning,
  },
  [NotificationsActionType.CallIncoming]: {
    icon: PhoneIcon,
    color: NotificationsActionColor.Primary,
  },
  [NotificationsActionType.EngineStart]: {
    icon: EngineIcon,
    color: NotificationsActionColor.Success,
  },
  [NotificationsActionType.EngineEnd]: {
    icon: EngineIcon,
    color: NotificationsActionColor.Danger,
  },
  [NotificationsActionType.InventoryTradeFailed]: {
    icon: WarningIcon,
    color: NotificationsActionColor.Danger,
  },
  [NotificationsActionType.InventoryTradeSuccess]: {
    icon: GiveFiveIcon,
    color: NotificationsActionColor.Success,
  },
  [NotificationsActionType.InventoryTradeCancelled]: {
    icon: TradeIcon,
    color: NotificationsActionColor.Warning,
  },
  [NotificationsActionType.InventoryTradeCancelledOther]: {
    icon: TradeIcon,
    color: NotificationsActionColor.Warning,
  },
  [NotificationsActionType.InventoryNotEnoughSpace]: {
    color: NotificationsActionColor.Warning,
  },
  [NotificationsActionType.InventoryNotEnoughSpaceOther]: {
    color: NotificationsActionColor.Warning,
  },
  [NotificationsActionType.InventoryTradeNotEnoughMoneyOther]: {
    icon: CashIcon,
    color: NotificationsActionColor.Warning,
  },
  [NotificationsActionType.NotificationSystemTypeInventoryTradeFailed]: {
    icon: TradeIcon,
    color: NotificationsActionColor.Danger,
  },
  [NotificationsActionType.FridgeNotEnoughtProducts]: {
    icon: Food2Icon,
    color: NotificationsActionColor.Danger,
  },
  [NotificationsActionType.FridgeProductsRestocked]: {
    icon: Food2Icon,
    color: NotificationsActionColor.Success,
  },
  [NotificationsActionType.NotEnoughMoney]: {
    icon: CashIcon,
    color: NotificationsActionColor.Danger,
  },
};
